MeasurementSystem.$inject = ["MiscModel", "$q", "Profile", "AuthenticationNew"];export function MeasurementSystem(MiscModel, $q, Profile, AuthenticationNew) {
  "ngInject";
  var _msystem;
  var _onMeasurementSystemCallbacks = [];
  var _currency;

  var MeasurementSystem = {
    getCurrency: getCurrency,
    getMeasurementSystem: getMeasurementSystem,
    setMeasurementSystem: setMeasurementSystem,
    convertCmToInch: convertCmToInch,
    convertKgToLbs: convertKgToLbs,
    convertLbsToKg: convertLbsToKg,
    convertOzToL: convertOzToL,
    convertInchToCm: convertInchToCm,
    onMeasurementSystemChanged: onMeasurementSystemChanged };


  return MeasurementSystem;

  function getCurrency() {
    if (_currency) {
      var ret = $q.resolve(angular.copy(_currency));
      return ret;
    } else
    {
      var req = Profile.getMisc('currency').then(function (res) {
        _currency = res.data.value;
        return angular.copy(_currency);
      }, function (err) {
        /*
                         if (_browserLocale() == 'en-gb')
                           _currency = 'GBP';
                         else if (_browserLocale() == 'en-au')
                           _currency = 'AUD';
                         else if (_browserLocale() == 'en-ca')
                           _currency = 'CAD';
                         else
                          _currency = 'USD';
                          */
        _currency = 'USD';
        if (AuthenticationNew.isAuthenticated())
        return _setCurrency(_currency);else

        return angular.copy(_currency);
      });
      return req;
    }
  }

  function _setCurrency(currency) {
    _currency = currency;
    var req = Profile.createMisc({ key: 'currency', value: _currency }).then(function (res) {
      return angular.copy(_currency);
    }, function (err) {
      return Profile.updateMisc({ key: 'currency', value: _currency }).then(function (res) {
        return angular.copy(_currency);
      });
    });
    return req;
  }

  function _fireMeasurementSystemCallbacks(data) {
    _onMeasurementSystemCallbacks.forEach(function (cb) {
      if (angular.isFunction(cb)) {
        cb(data);
      }
    });
  }

  function onMeasurementSystemChanged(callback) {
    // call when external change has happened
    var idx = _onMeasurementSystemCallbacks.push(callback) - 1;

    // return unsubscribe function
    var unsub = function unsub() {
      delete _onMeasurementSystemCallbacks[idx];
    };
    return unsub;
  }

  function _browserLocale() {
    var lang;

    if (navigator.languages && navigator.languages.length) {
      // latest versions of Chrome and Firefox set this correctly
      lang = navigator.languages[0];
    } else if (navigator.userLanguage) {
      // IE only
      lang = navigator.userLanguage;
    } else {
      // latest versions of Chrome, Firefox, and Safari set this correctly
      lang = navigator.language;
    }
    lang = lang.toLowerCase();
    return lang;
  }

  function getMeasurementSystem() {
    if (_msystem) {
      var ret = $q.resolve(angular.copy(_msystem));
      return ret;
    } else
    {
      var req = MiscModel.get('measurementSystem').then(function (res) {
        _msystem = res.value;
        return angular.copy(_msystem);
      }, function (err) {
        if (_browserLocale() == 'en-us')
        _msystem = 'US';else

        _msystem = 'SI';
        if (AuthenticationNew.isAuthenticated())
        return setMeasurementSystem(_msystem);else

        return angular.copy(_msystem);
      });
      return req;
    }
  }

  function setMeasurementSystem(msystem) {
    _msystem = msystem;
    var req = Profile.createMisc({ key: 'measurementSystem', value: _msystem }).then(function (res) {
      //_fireMeasurementSystemCallbacks(_msystem);
      return angular.copy(_msystem);
    }, function (err) {
      return Profile.updateMisc({ key: 'measurementSystem', value: _msystem }).then(function (res) {
        //_fireMeasurementSystemCallbacks(_msystem);
        return angular.copy(_msystem);
      });
    });
    return req;
  }

  function convertInchToCm(inch) {
    if (inch === null || inch === '' || inch === undefined) return inch;
    return parseFloat(inch * 2.54).toFixed(2);
  }

  function convertCmToInch(cm) {
    if (cm === null || cm === '' || cm === undefined) return cm;
    return parseFloat(cm * 0.393701).toFixed(2);
  }

  function convertKgToLbs(kg) {
    if (kg === null || kg === '' || kg === undefined) return kg;
    return parseFloat(kg * 2.20462).toFixed(2);
  }

  function convertLbsToKg(lbs) {
    if (lbs === null || lbs === '' || lbs === undefined) return lbs;
    return parseFloat(lbs * 0.453592).toFixed(2);
  }

  function convertOzToL(oz) {
    if (oz === null || oz === '' || oz === undefined) return oz;
    return parseFloat(oz * 0.0295735).toFixed(2);
  }
}